import React from 'react'
import { isNilOrEmpty, prop } from '@soltalabs/ramda-extra'
import { connect } from '@soltalabs/stateless'
import { forecastTime$ } from 'modules/ravensdown/forecast'
import { getColorFromAssessmentScore } from 'utils/assessment'

import { SiteCard } from 'components/ravensdown/common/SiteCard'

import { ReactComponent as PinIcon } from 'assets/pin.svg'
import { ReactComponent as LargePinIcon } from 'assets/pin-large.svg'

import { StyledMarker, StyledPopup } from './styles'

const Connected = connect(() => ({
  forecastTime: forecastTime$,
}))(Pin)

function Pin({
  forecastTime,

  isHovered,
  isSelected,

  name,
  assessments,
  location,

  onClick,
  onClosePopup,
}) {
  if (isNilOrEmpty(assessments)) {
    return null
  }

  const highlighted = isSelected || isHovered
  const offsetTop = highlighted ? -33 : -20
  const offsetLeft = highlighted ? -20 : -15
  const latitude = location.coordinates[1]
  const longitude = location.coordinates[0]
  const currentAssessment = assessments.find(
    ({ assessmentValidityPeriodStart }) =>
      assessmentValidityPeriodStart === forecastTime
  )
  const color = getColorFromAssessmentScore(prop('score')(currentAssessment))

  return (
    <div>
      {isSelected && (
        <StyledPopup
          latitude={latitude}
          longitude={longitude}
          offsetTop={-38}
          offsetLeft={-7}
          closeButton
          closeOnClick={false}
          anchor="bottom"
          onClose={onClosePopup}
        >
          <SiteCard isCard={false} name={name} assessments={assessments} />
        </StyledPopup>
      )}
      <StyledMarker
        latitude={latitude}
        longitude={longitude}
        offsetLeft={offsetLeft}
        offsetTop={offsetTop}
        selected={isSelected}
      >
        {highlighted ? (
          <LargePinIcon fill={color} onClick={onClick} />
        ) : (
          <PinIcon fill={color} onClick={onClick} />
        )}
      </StyledMarker>
    </div>
  )
}

export { Connected as Pin }
